<template>
  <!-- Naming modal shown on first visit -->
  <div v-if="showNameModal" class="name-modal">
    <div class="name-card">
      <h3>首次进入，请为角色起名</h3>
      <input
        v-model="nameInput"
        @keyup.enter="submitName"
        placeholder="输入名字..."
        ref="nameInputField"
      />
      <div class="name-buttons">
        <button @click="submitName">确认</button>
        <button @click="randomName">随机</button>
      </div>
    </div>
  </div>
</template>

<script>
import gameController from '../game-controller/GameController.js';
import { RANDOM_NAMES } from '../config';

export default {
  name: 'NameModal',
  props: {
    showNameModal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      nameInput: ''
    };
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.nameInputField) {
        this.$refs.nameInputField.focus();
      }
    });
  },
  methods: {
    submitName() {
      const name = (this.nameInput || '').trim();
      if (!name) {
        this.$emit('message', '请输入有效名字。');
        return;
      }

      try {
        const result = gameController.executeCommand('name ' + name);
        if (Array.isArray(result)) {
          result.forEach(msg => this.$emit('message', msg));
        } else if (result) {
          this.$emit('message', result);
        }

        // Check if naming succeeded
        if (gameController.getGameState().isNamed) {
          this.$emit('name-submitted', name);
          this.nameInput = '';
        }
      } catch (error) {
        this.$emit('message', '起名失败：' + (error.message || error));
      }
    },

    randomName() {
      this.nameInput = RANDOM_NAMES[Math.floor(Math.random() * RANDOM_NAMES.length)];
      this.submitName();
    }
  }
};
</script>

<style scoped>
/* naming modal */
.name-modal {
  position: absolute;
  inset: 0px 0px 0px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(2, 6, 23, 0.6);
  z-index: 200;
}

.name-card {
  background: #071328;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #123;
  color: #dbeafe;
  min-width: 320px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.name-card input {
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #22303f;
  background: #081425;
  color: #e6eef8;
}

.name-buttons {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.name-buttons button {
  padding: 6px 10px;
  border-radius: 4px;
  border: none;
  background: #0ea5a2;
  color: #042f2e;
  cursor: pointer;
}
</style>
